<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateSetup from './list/setup'
import { notify } from '@/helpers/notify'
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'
import SearchableSelect from '@/components/SearchableSelect'

export default {
    page: {
        title: "Söküm | Sökülemeyen | Kayıp Listesi",
    },
    mixins: [ datatableMixin ],
    components: {
        Layout,
        PageHeader,
        CreateSetup,
        Datatable,
        SearchableSelect
    },
    data() {
     return {
            title: "SÖKÜM LİSTESİ",
            items: [
                { text: "ANASAYFA", href: "/" },
                { text: "SÖKÜM LİSTESİ", active: true }
            ],
            listeType:1,
            data:{},
            modelOpen:0,

            searchParams: {},
            form: {
                province: null,
                bolge: null
            },
            ilList: [],
            bucakList: [],
            buttons:[
                { title:"Randevu Ver", icon:'bx bx-calendar-event', func:this.createSetup},
                { title:"Söküldü Olarak İşaretle", icon:'bx bx-check', func:this.sokum},
                { title:"Sökülemeyen Listesine Gönder", icon:'bx bx-link-external', func:this.sokulmeyen},
                { title:"Kayıp Listesine Gönder", icon:'bx bx-link-external', func:this.kayip},
                { title:"Listeden Kaldır", icon:'bx bx-x', func:this.cikart},
            ],
            columns: [
                { name: '', key: 'action', orderable: false  },
                { name: 'Kullanıcı Adı', key: 'username',  width: 350 },
                { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                { name: 'Randevu Tarihi', key: 'appointment', className: 'text-end', orderable: true, width: 150  },
                { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', width: 150  },
                { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
                { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                { name: 'İl', key: 'province', className: 'text-end', width: 150  },
                { name: 'Bölge', key: 'township', className: 'text-end',  width: 150  },
                { name: 'Adres', key: 'address', className: 'text-end',  width: 150  },
                { name: 'Personel', key: 'user_name', className: 'text-end',  width: 150  },
            ],
            tableData: {
            detail: false,
            excel: true,
                searchable:{
                    visible:true,
                    placeholder:"İsim Soyisim Ara"
                }
            },
            endpoint: '/listeler/sokum-listesi',
            exportName: 'SOKUM_LISTESI'
        };
    },

    mounted() {
        this.loadIlList()
    },

    methods: {
        async loadPage() {

            this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true

            const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
            if (this.params.page === 1) {
                this.tableData.data = response.data.data;
            } else {
                this.tableData.data = [...this.tableData.data, ...response.data.data];
            }

            this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
            this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
        },

        locationFilters() {
            const filters = {}
            if (this.form.province) filters.province = this.form.province
            if (this.form.bolge) filters.bolge = this.form.bolge
            return filters
        },

        handleFilterChange() {
            this.searchParams = {
                ...this.locationFilters(),
                ...(this.listeType == 2 ? { status: 8 } : {}),
                ...(this.listeType == 3 ? { status: 7 } : {}),
            }
            this.params.page = 1
            this.loadPage()
        },

        async loadIlList() {
            const response = await this.$http.post('/address/il/0')
            this.ilList = response.data || []
        },

        async onProvinceChange() {
            this.form.bolge = null
            this.bucakList = []
            if (this.form.province) {
                const response = await this.$http.post(`/address/bucak/${this.form.province}`)
                this.bucakList = response.data || []
            }
            this.handleFilterChange()
        },

        clearFilter(field) {
            this.form[field] = null
            if (field === 'province') {
                this.form.bolge = null
                this.bucakList = []
            }
            this.handleFilterChange()
        },

        appointment(obj){
            if(obj.appointment_at){
                if(obj.postpone){
                return  "<span class='badge rounded-pill bg-warning font-size-12'>Ertelenmiş</span> " +  obj.histories.length > 0 ? obj.histories[0].description : '';
                }
                return this.formatDate(obj.appointment_at, 'DD.MM.YYYY HH') + ':00'
            }
            return  '-'
        },

        expiredate(expiredate){
            return this.formatDate(expiredate, "DD.MM.YYYY HH:mm")
        },


        cikart(props){


            this.$http.post('/listeler/uzatmayanlar/event', { cikart : props.subs_id, type: this.listeType })
                .then(() => {
                    notify.success('Başarılı')
                    this.loadPage()
                })
        },

        sokum(props){
            this.$http.post('/listeler/uzatmayanlar/event', { sokuldu : props.subs_id })
                .then(() => {
                    notify.success('Başarılı')
                    this.loadPage()
                })
        },

        sokulmeyen(props){
            this.$http.post('/listeler/uzatmayanlar/event', { sokulmeyen : props.subs_id })
                .then(() => {
                    notify.success('Başarılı')
                    this.loadPage()
                })
        },

        kayip(props){
            this.$http.post('/listeler/uzatmayanlar/event', { kayip : props.subs_id })
                .then(() => {
                    notify.success('Başarılı')
                    this.loadPage()
                })
        },

        createSetup(props){
            this.modelOpen = Math.floor(Math.random() * 1000)
            this.data = { type:2, subs_id :props.subs_id, tech_id:props.id  }
            this.$parent.$bvModal.show('setup')
        },
        popoverContent(histories) {
            const listItems = histories.map(history => {
            return `
                <li>${history.description}</li>
            `;
            }).join('');

            return `<ul>${listItems}</ul>`;
        },

        sekme(idx){
            this.listeType = idx

            this.params= {
                    per_page: 50,
                    page: 1
                }
            this.sort.column= null
            this.sort.order= null
            this.searchQuery= ''

            if(idx == 1){
                this.exportName= 'SOKUM_LISTESI'
                this.searchParams = this.locationFilters()
                this.buttons=[
                    { title:"Randevu Ver", icon:'bx bx-calendar-event', func:this.createSetup},
                    { title:"Söküldü Olarak İşaretle", icon:'bx bx-check', func:this.sokum},
                    { title:"Sökülemeyen Listesine Gönder", icon:'bx bx-link-external', func:this.sokulmeyen},
                    { title:"Kayıp Listesine Gönder", icon:'bx bx-link-external', func:this.kayip},
                    { title:"Listeden Kaldır", icon:'bx bx-x', func:this.cikart},
                ],
                this.items[1].title = 'SÖKÜM LİSTESİ'
                this.columns= [
                    { name: '', key: 'action', orderable: false  },
                    { name: 'Kullanıcı Adı', key: 'username',  width: 350 },
                    { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                    { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', width: 150  },
                    { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
                    { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                    { name: 'İl', key: 'province', className: 'text-end', width: 150  },
                    { name: 'Bölge', key: 'township', className: 'text-end',  width: 150  },
                    { name: 'Adres', key: 'address', className: 'text-end',  width: 150  },
                    { name: 'Personel', key: 'user_name', className: 'text-end',  width: 150  },
                    { name: 'Randevu Tarihi', key: 'appointment', className: 'text-end', orderable: true, width: 150  },
                ]

                this.loadPage()
            }

            if(idx == 2){
                this.exportName= 'SOKULEMEYEN_LISTESI'
                this.searchParams = { status: 8, ...this.locationFilters() }
                this.buttons=[
                    { title:"Geri Al",  func:this.cikart},
                ],
                this.items[1].title = 'SÖKÜLEMEYEN LİSTESİ'
                this.columns= [
                    { name: '', key: 'action', orderable: false  },
                    { name: 'Kullanıcı Adı', key: 'username', width: 350 },
                    { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                    { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', width: 150  },
                    { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
                    { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                    { name: 'İl', key: 'province', className: 'text-end', width: 150  },
                    { name: 'Bölge', key: 'township', className: 'text-end', width: 150  },
                    { name: 'Adres', key: 'address', className: 'text-end', width: 150  }
                ]
                this.loadPage()
            }

            if(idx == 3){
                this.exportName= 'KAYIP_LISTESI'
                this.searchParams = { status: 7, ...this.locationFilters() }
                this.buttons=[
                    { title:"Geri Al",  func:this.cikart},
                ],

                this.columns= [
                    { name: '', key: 'action', orderable: false  },
                    { name: 'Kullanıcı Adı', key: 'username', width: 350 },
                    { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                    { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', width: 150  },
                    { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
                    { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                    { name: 'İl', key: 'province', className: 'text-end', width: 150  },
                    { name: 'Bölge', key: 'township', className: 'text-end', width: 150  },
                    { name: 'Adres', key: 'address', className: 'text-end', width: 150  }
                ]

                this.loadPage()
            }

        }
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />
    <CreateSetup
        :randevu="true"
        :data="modelOpen"
        :type="data.type"
        :subs_id="data.subs_id"
        :tech_id="data.tech_id"
        @loadItems="loadPage"
    />

    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: listeType == 1 }" aria-current="page" href="#" @click.prevent="sekme(1)">Söküm Listesi</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: listeType == 2 }" aria-current="page" href="#" @click.prevent="sekme(2)">Sökülemeyen Listesi</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: listeType == 3 }" aria-current="page" href="#" @click.prevent="sekme(3)">Kayıp Listesi</a>
          </li>
        </ul>
            <div class="card mb-3">
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label class="d-flex justify-content-between">
                                    İl
                                    <span
                                        v-if="form.province"
                                        class="text-danger"
                                        style="cursor:pointer"
                                        @click="clearFilter('province')"
                                    >temizle</span>
                                </label>
                                <SearchableSelect
                                    v-model="form.province"
                                    :options="ilList"
                                    label="name"
                                    :reduceFn="o => o.id"
                                    placeholder="İl ara / seçiniz"
                                    searchable
                                    @input="onProvinceChange"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label class="d-flex justify-content-between">
                                    Bölge
                                    <span
                                        v-if="form.bolge"
                                        class="text-danger"
                                        style="cursor:pointer"
                                        @click="clearFilter('bolge')"
                                    >temizle</span>
                                </label>
                                <SearchableSelect
                                    v-model="form.bolge"
                                    :options="bucakList"
                                    label="name"
                                    :reduceFn="o => o.id"
                                    placeholder="Bölge ara / seçiniz"
                                    searchable
                                    @input="handleFilterChange"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
            <Datatable
                :columns="columns"
                :tableData="tableData"
                @sort-column="handleSortColumn"
                @search-query="reLoadPage"
                @excel-export="excelExport"
                :loading="isLoading"
                :poading="pageLoading">

            <template #expiredate="{ row }">
                {{ expiredate(row.expiredate) }}
            </template>

            <template #phonenumber="{ row }">
                <a :href="`tel:${row.phonenumber}`"  >{{row.phonenumber}}</a>
            </template>

            <template #phonenumber2="{ row }">
                 <a target="_blank" :href='`https://wa.me/${row.phonenumber2}`' >{{ row.phonenumber2}}</a>
            </template>

            <template #address="{ row }">
                <span v-b-popover.hover.auto="row.address">{{ row.address }}</span>
            </template>

            <template #appointment="{ row }">

                <div v-if="row.postpone">
                    <span v-if="row.hasOwnProperty('histories') && row.histories.length > 0"  v-b-popover.hover.auto.html="popoverContent(row.histories)">
                        <span class='badge rounded-pill bg-warning font-size-12'>Ertelenmiş</span>
                    </span>
                </div>
                <div v-else>
                {{ formatDate(row.appointment_at, 'DD.MM.YYYY HH') }}
                </div>
            </template>

            <template #action="{ row }">
                <b-dropdown
                    toggle-class="font-size-16 p-0"
                    toggle-tag="a"
                    variant="white"
                    append-to-body
                    >
                    <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                    </template>
                        <b-dropdown-item  v-for="(button,i) in buttons"  :key="i" @click="button.func(row)"> {{ button.title }}</b-dropdown-item>
                </b-dropdown>
            </template>
            </Datatable>
        </div>
      </div>
    </div>
  </Layout>
</template>